const masqueradedUser = () => {
  let authDetails = localStorage.getItem('masqueradedUser');
  if (authDetails) {
    authDetails = JSON.parse(authDetails);
  }
  return authDetails;
};

export default masqueradedUser;
